<ng-container *ngIf="size && !size.pieces">
  <div class="d-flex justify-content-between font-sm">
    <div>{{size.value}}&nbsp;{{size.measurement}}&nbsp;{{size.definition ? '| ' + size.definition : ''}}</div>
    <div class="extra-price">
      {{orderLine.price | currencyFormat : currency}}
    </div>
  </div>
</ng-container>

<ng-container *ngIf="size && size.pieces && hasExtraProducts()">
  <div class="d-flex justify-content-between font-sm">
    <div class="text-muted first-letter-capitalize">
      {{('cakeBuilder.sizeUnits.unitType.' + orderLine.size.details.unit?.key) | translate}}
    </div>
    <div class="extra-price">
      {{orderLine.price | currencyFormat : currency}}
    </div>
  </div>
</ng-container>

<div class="pt-1 font-sm" *ngIf="linesByTypes[TYPES.QUESTION].length">
  <div class="mt-3" *ngFor="let question of linesByTypes[TYPES.QUESTION]">
    <div class="text-muted">{{question.name}}</div>
    <div class="d-flex justify-content-between">
      <div [innerHTML]="question.details.answer"></div>
      <div class="extra-price">+{{question.price | currencyFormat: currency}}</div>
    </div>
  </div>
</div>

<div class="mt-3 font-sm"
     *ngIf="linesByTypes[TYPES.GREETING_CARD].length">
  <div class="text-muted">{{'cart.orderLine.greetingCard' | translate}}</div>
  <div class="d-flex justify-content-between">
    <div [innerHTML]="linesByTypes[TYPES.GREETING_CARD][0].details.text"></div>
    <div class="extra-price">+{{linesByTypes[TYPES.GREETING_CARD][0].price | currencyFormat: currency}}</div>
  </div>
</div>

<div class="mt-3 font-sm"
     *ngIf="linesByTypes[TYPES.PICTURE].length">
  <ng-container *ngFor="let picture of linesByTypes[TYPES.PICTURE]">
    <div class="d-flex justify-content-between">
      <div class="text-muted">{{ picture.name }}</div>
      <div class="extra-price">+{{picture.price | currencyFormat: currency}}</div>
    </div>

    <div class="picture mt-1">
      <div class="d-inline-block"
           [imagePreviewTrigger]="picture.details.url">
        <img [src]="picture.details.url" [alt]="'cart.orderLine.imageOnCake' | translate">
      </div>
    </div>
  </ng-container>
</div>

<div class="pt-1 font-sm" *ngIf="linesByTypes[TYPES.EXTRA_PRODUCT].length">
  <div class="mt-3" *ngFor="let extraProduct of linesByTypes[TYPES.EXTRA_PRODUCT]">
    <div class="text-muted"
         *ngIf="extraProduct.product">
      {{extraProduct.product?.extraGroup?.name}}
    </div>

    <div class="d-flex justify-content-between">
      <div>{{extraProduct.name}}</div>
      <div class="extra-price">+{{extraProduct.price | currencyFormat: currency}}</div>
    </div>
  </div>
</div>

<div class="pt-1 font-sm" *ngIf="linesByTypes[TYPES.DEPOSIT].length">
  <div class="mt-3">
    <div class="d-flex justify-content-between">
      <div>{{ linesByTypes[TYPES.DEPOSIT][0].name }}</div>
      <div class="extra-price">+{{linesByTypes[TYPES.DEPOSIT][0].price | currencyFormat: currency}}</div>
    </div>
  </div>
</div>

